import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

const SMS = [
  ["Text messages (SMS)", "If you check the \"Text me too\" box in Settings → Notifications and enter your mobile number, or text START to our number, you agree to receive texts from Locked In Forever about your account: appointment and session reminders, meeting invites, RSVP and event updates, and replies to your support questions."],
  ["How often", "Message frequency varies with your bookings and activity. Message and data rates may apply."],
  ["Stopping texts", "Reply STOP at any time to stop receiving texts. You'll get one confirmation and nothing more. Reply START to resubscribe. Reply HELP for help, or email info@lockedinforever.com."],
  ["Carriers", "Carriers are not liable for delayed or undelivered messages."],
];

const PAGES = {
  privacy: {
    title: "Privacy Policy",
    intro: "This policy explains what Locked In Forever collects, why, and the choices you have.",
    sections: [
      ["What we collect", "Account details you give us (name, email, phone), wedding details you add, photos and videos you upload, and basic usage data needed to run the site."],
      ["How we use it", "To run your wedding site and planning tools, send the emails and texts you asked for, process payments, and keep the platform safe."],
      ["Mobile numbers", "We never sell, rent or share your mobile number or text-message opt-in with third parties or affiliates for their marketing. We share it only with the texting providers that deliver our messages."],
      ["Your choices", "You can edit or delete your details in Settings, turn emails or texts off at any time, and ask us to delete your account by emailing info@lockedinforever.com."],
      ["Contact", "Questions? Email info@lockedinforever.com."],
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "By using Locked In Forever you agree to these terms.",
    sections: [
      ["Your account", "Keep your login safe and the details on your account accurate. You're responsible for what you post."],
      ["Your content", "You own the photos, videos and text you upload. You give us permission to show them on your wedding site and in the places you choose to share them."],
      ["Payments", "Paid plans and purchases are billed as shown at checkout."],
      ...SMS,
      ["Contact", "Questions? Email info@lockedinforever.com."],
    ],
  },
};

function LegalPage({ kind }) {
  const p = PAGES[kind];
  return (
    <div className="bg-[var(--bg)] min-h-screen" data-testid={`legal-${kind}`}>
      <Seo title={`${p.title} · Locked In Forever`} description={p.intro} />
      <Navbar />
      <main className="container-wide px-6 md:px-12 pt-32 pb-24 max-w-3xl">
        <p className="font-script text-[var(--gold)] text-3xl">Locked In Forever</p>
        <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl mb-4">{p.title}</h1>
        <p className="text-[#5c544b] mb-10">{p.intro}</p>
        <div className="space-y-8">{p.sections.map(([h, t]) => <section key={h}><h2 className="font-serif text-2xl mb-2">{h}</h2><p className="text-sm md:text-base leading-relaxed text-[#3d3730]">{t}</p></section>)}</div>
      </main>
      <Footer />
    </div>
  );
}

export function PrivacyPage() { return <LegalPage kind="privacy" />; }
export function TermsPage() { return <LegalPage kind="terms" />; }
